import { render } from "./FormPQR.vue?vue&type=template&id=44be4ef4"
import script from "./FormPQR.vue?vue&type=script&lang=js"
export * from "./FormPQR.vue?vue&type=script&lang=js"

import "./FormPQR.vue?vue&type=style&index=0&id=44be4ef4&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__